const getBudgetValue = ({ minBudget, maxBudget, maxPrice }) => {
  let budgetValue = `${minBudget}-${maxBudget}`;

  if (maxBudget === maxPrice) {
    budgetValue = minBudget ? `${minBudget}` : '';
  }
  return budgetValue;
};

export default getBudgetValue;
